const baimahu_1 = require('@tugou/baimahu');
export async function upload(axios: any, url: string, file: File) {
  const suffix = baimahu_1.string.suffix(file.name);
  const res = await axios.get(url, { params: { suffix } });

  const { data, status } = res.data;

  if (status !== 200) return null;

  const param = new FormData();
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      param.append(key, data[key]);
    }
  }
  param.append('file', file);
  const oss_ret = await axios.post(`https://${data.endpoint}`, param);
  if (oss_ret.status !== 204) {
    return null;
  }
  return { src: `https://${data.host}/${data.key}` };
}
